import { render, staticRenderFns } from "./SubmissionReceiveLabelIndex.vue?vue&type=template&id=0e6794fe"
import script from "./SubmissionReceiveLabelIndex.vue?vue&type=script&lang=js"
export * from "./SubmissionReceiveLabelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports